import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import styles from './ViewAllButton.module.scss';

interface ViewAllButtonProps {
	onClick?: () => void;
	className?: string;
}

const ViewAllButtonComponent = ({ onClick, className = "" }: ViewAllButtonProps) => {

  	const { t } = useTranslation();

  	return (
    	<button className={`${styles.viewAllButton} ${className}`} onClick={onClick}>
      		<Icon type='general-ui-plus' strokeWidth={2} size='small' className={styles.icon} />
      		<span className={styles.copy}>{t('photo_prints.view_all')}</span>
    	</button>
  	);
};

export const ViewAllButton = React.memo(ViewAllButtonComponent);